<template>
  <div>
    <template v-for="(point, index) in filteredPointList">
      <MyMarker
        :key="index"
        :point="point"
        :has-edit-permission="hasEditPermission"
      />
    </template>
  </div>
</template>

<script>
import MyMarker from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Map/mapbox/Marker'
import { getters } from '@/vuex/modules/pointGroupOperation/constants'

export default {
  name: 'MarkerWrapper',
  components: {
    MyMarker,
  },
  props: { pointList: Array, hasEditPermission: Boolean },
  computed: {
    filteredPointList() {
      return this.$store.getters[getters.filteredPointList](this.pointList)
    },
  },
}
</script>

<style scoped></style>
